export default "__VITE_ASSET__h5tzfIQH__"